<template>
  <div v-if="status === 'consent'"
    class="w-screen min-h-screen overflow-y-auto flex flex-col items-center"
    style="background-color: #06070F; padding-top: 44px; padding-bottom: 40px;">
    <div class="flex flex-col items-center" style="width: 440px;">

      <!-- Logo + MCP pill row -->
      <div class="flex items-center justify-center gap-3" style="height: 32px;">
        <img src="../../assets/images/foreplay-logo.png" style="width: 108px; height: 32px;" />
        <div class="flex items-center rounded-lg" style="height: 24px; padding: 2px; gap: 2px; background-color: rgba(255,255,255,0.12);">
          <MCPLogoIcon :width="20" :height="20" stroke="#FFFFFF" />
          <span class="text-white" style="padding: 0 4px; font-family: Inter; font-weight: 500; font-size: 14px; line-height: 20px;">MCP</span>
        </div>
      </div>

      <!-- Heading block -->
      <div class="flex flex-col gap-2 items-center text-center" style="margin-top: 40px; max-width: 400px;">
        <h1 class="text-white" style="font-family: Inter; font-weight: 500; font-size: 16px; line-height: 24px; margin: 0;">
          Connect {{ friendlyClientName }} to Foreplay
        </h1>
        <p style="font-family: Inter; font-weight: 400; font-size: 16px; line-height: 24px; color: rgba(255,255,255,0.76); margin: 0;">
          {{ friendlyClientName }} is requesting access to your Foreplay workspace through the Public API.
        </p>
      </div>

      <!-- Workspace card -->
      <div class="rounded-2xl flex flex-col w-full"
        style="margin-top: 20px; padding: 4px; backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px);"
        :style="{ backgroundImage: consentTheme.cardGradient }">
        <!-- Outer header -->
        <div class="flex flex-col" style="padding: 12px; gap: 4px;">
          <div :style="{ color: consentTheme.accentColor, fontFamily: 'Inter', fontWeight: 500, fontSize: '14px', lineHeight: '20px' }">
            {{ consentTheme.outerTitle }}
          </div>
          <div :style="{ color: consentTheme.accentColorAlpha76, fontFamily: 'Inter', fontWeight: 400, fontSize: '14px', lineHeight: '20px' }">
            {{ consentTheme.outerBody }}
          </div>
        </div>
        <!-- Inner team row -->
        <div class="rounded-xl flex flex-col" style="background-color: rgba(6,7,15,0.6); padding: 12px; gap: 12px;">
          <div class="flex flex-col" style="gap: 4px;">
            <div :style="{ color: consentTheme.accentColor, fontFamily: 'Inter', fontWeight: 500, fontSize: '14px', lineHeight: '20px' }">
              <template v-if="getTeam && getTeam.name">&#x201C;{{ getTeam.name }}&#x201D; {{ userEmail }}&#x2019;s team</template>
              <template v-else>{{ workspaceLabel }}</template>
            </div>
            <div :style="{ color: consentTheme.accentColorAlpha76, fontFamily: 'Inter', fontWeight: 400, fontSize: '14px', lineHeight: '20px' }">
              {{ consentTheme.innerBody }}
            </div>
          </div>
          <a :href="consentTheme.actionHref"
            class="flex items-center"
            style="gap: 4px; opacity: 0.68; text-decoration: none;"
            :style="{ color: consentTheme.accentColor, fontFamily: 'Inter', fontWeight: 500, fontSize: '14px', lineHeight: '20px' }">
            <span>{{ consentTheme.actionLabel }}</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M7.5 4l5 6-5 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </a>
        </div>
      </div>

      <!-- Includes label -->
      <div class="text-white text-center w-full"
        style="margin-top: 8px; padding: 8px; font-family: Inter; font-weight: 500; font-size: 14px; line-height: 20px;">
        Includes
      </div>

      <!-- Feature list -->
      <div class="rounded-xl overflow-hidden w-full" style="border: 1px solid rgba(255,255,255,0.12);">
        <div v-for="(f, idx) in features" :key="f.id"
          class="flex items-start"
          :style="{ padding: '8px', paddingRight: '20px', gap: '8px', borderBottom: idx === features.length - 1 ? 'none' : '1px solid rgba(255,255,255,0.12)' }">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" class="flex-shrink-0">
            <path d="M5 10l3.5 3.5L15 7" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <div class="flex flex-col min-w-0" style="gap: 2px;">
            <div class="text-white" style="font-family: Inter; font-weight: 500; font-size: 14px; line-height: 20px;">{{ f.title }}</div>
            <div style="font-family: Inter; font-weight: 400; font-size: 14px; line-height: 20px; color: rgba(255,255,255,0.76);">{{ f.description }}</div>
          </div>
        </div>
      </div>

      <!-- Footer note -->
      <p class="text-center w-full"
        style="margin-top: 8px; padding: 8px; font-family: Inter; font-weight: 400; font-size: 12px; line-height: 16px; color: rgba(255,255,255,0.76);">
        {{ friendlyClientName }} can refresh its connection automatically using rotating refresh tokens.
        You can revoke this access at any time from your account settings.
      </p>

      <!-- Buttons row -->
      <div class="flex items-center justify-center w-full" style="margin-top: 20px; gap: 12px;">
        <button class="mcp-deny-btn" @click="cancel">Deny</button>
        <button class="mcp-allow-btn" :disabled="!canApprove" @click="approve">Allow Access</button>
      </div>
    </div>
  </div>

  <div v-else class="w-screen h-screen flex flex-col items-center justify-center overflow-hidden" style="background-color: #020308">
    <div class="flex flex-col items-center w-full pb-10 px-3" style="max-width: 400px;">
      <!-- Logo -->
      <img src="../../assets/images/foreplay-logo.png" style="width: 136px; height: 40px;" />

      <!-- invalid_params -->
      <div v-if="status === 'invalid_params'" class="w-full mt-12 flex flex-col items-center gap-3">
        <BaseText type="heading" size="md" class="text-white text-center">Invalid request</BaseText>
        <BaseText type="body" size="sm" class="text-neutral-alpha-650 text-center">{{ paramError }}</BaseText>
      </div>

      <!-- login: email/password form (copied from LoginView) -->
      <form v-else-if="status === 'login'" class="w-full mt-12" @submit.prevent="sendEmailLink">
        <!-- Email Input -->
        <BaseText type="label" size="md" class="text-white w-full mb-1">
          Email
        </BaseText>
        <div class="input-container w-full flex items-center" :class="{'active': email?.length || emailInputFocused, 'errored': emailError}">
          <input v-model="email" class="form-input flex-grow min-w-0" placeholder="Enter your email address" type="email"
          @focus="emailInputFocused = true" @blur="emailInputFocused = false" @input="() => emailError = false" />
          <transition>
            <InfoIcon v-if="emailError" style="color: #DF1C41" />
          </transition>
        </div>
        <transition name="error">
          <div v-if="emailError" class="w-full flex items-end h-7">
            <BaseText type="body" size="sm" style="color: #DF1C41">
              Please enter a valid email address
            </BaseText>
          </div>
        </transition>
        <!-- Password Input -->
        <BaseText type="label" size="md" class="text-white w-full mt-4 mb-1">
          Password
        </BaseText>
        <div class="input-container w-full flex items-center" :class="{'active': password?.length || passwordInputFocused, 'errored': passwordError}">
          <input v-model="password" class="form-input flex-grow min-w-0" placeholder="Enter your password" :type="showPassword ? 'text' : 'password'"
          @focus="passwordInputFocused = true" @blur="passwordInputFocused = false" @input="() => passwordError = false" />
          <button class="w-6 h-6 relative flex items-center cursor-pointer flex-shrink-0" style="color: rgba(255, 255, 255, 0.44)"
          type="button" @click="showPassword= !showPassword">
            <transition name="visibility">
              <InfoIcon v-if="passwordError" class="ml-auto" style="color: #DF1C41" />
              <svg v-else-if="showPassword" xmlns="http://www.w3.org/2000/svg" key="visible-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" class="h-4">
                <path d="M9.16536 4.42071C8.76872 4.5401 8.54397 4.95841 8.66335 5.35505C8.78273 5.75169 9.20105 5.97645 9.59768 5.85706L9.16536 4.42071ZM21.529 11.1176L22.1806 10.7462V10.7462L21.529 11.1176ZM19.1413 14.9666C18.8678 15.2776 18.8982 15.7515 19.2092 16.0251C19.5203 16.2986 19.9942 16.2682 20.2677 15.9571L19.1413 14.9666ZM21.5297 12.8811L20.8781 12.5098L20.8781 12.5098L21.5297 12.8811ZM3.28029 2.21967C2.9874 1.92678 2.51253 1.92678 2.21963 2.21967C1.92674 2.51256 1.92674 2.98744 2.21963 3.28033L3.28029 2.21967ZM2.47016 11.1188L3.12179 11.4901H3.12179L2.47016 11.1188ZM20.7196 21.7803C21.0125 22.0732 21.4874 22.0732 21.7803 21.7803C22.0732 21.4874 22.0732 21.0126 21.7803 20.7197L20.7196 21.7803ZM2.47125 12.8829L1.81966 13.2543H1.81966L2.47125 12.8829ZM10.2322 10.2322C10.5251 9.93934 10.5251 9.46447 10.2322 9.17157C9.9393 8.87868 9.46443 8.87868 9.17153 9.17157L10.2322 10.2322ZM14.8284 14.8284C15.1213 14.5355 15.1213 14.0607 14.8284 13.7678C14.5355 13.4749 14.0606 13.4749 13.7677 13.7678L14.8284 14.8284ZM9.59768 5.85706C13.5394 4.67067 17.9939 6.42962 20.8774 11.489L22.1806 10.7462C19.0295 5.21732 13.9174 2.99041 9.16536 4.42071L9.59768 5.85706ZM20.2677 15.9571C20.9622 15.1674 21.6043 14.2652 22.1814 13.2524L20.8781 12.5098C20.3482 13.4398 19.7644 14.258 19.1413 14.9666L20.2677 15.9571ZM20.8774 11.489C21.0579 11.8057 21.058 12.1942 20.8781 12.5098L22.1814 13.2524C22.6242 12.4754 22.6229 11.5222 22.1806 10.7462L20.8774 11.489ZM2.21963 3.28033L5.99934 7.06003L7.06 5.99937L3.28029 2.21967L2.21963 3.28033ZM3.12179 11.4901C4.21375 9.57383 5.53387 8.13258 6.95695 7.14609L6.10238 5.91332C4.47301 7.04281 3.00749 8.66097 1.81853 10.7475L3.12179 11.4901ZM5.99934 7.06003L16.9399 18.0006L18.0005 16.9399L7.06 5.99937L5.99934 7.06003ZM16.9399 18.0006L20.7196 21.7803L21.7803 20.7197L18.0005 16.9399L16.9399 18.0006ZM1.81966 13.2543C3.74764 16.6368 6.40542 18.7894 9.29529 19.6173C12.1917 20.4471 15.2481 19.9232 17.8975 18.0866L17.0429 16.8539C14.7434 18.4479 12.1496 18.8747 9.7084 18.1753C7.26065 17.4741 4.8934 15.6178 3.12283 12.5115L1.81966 13.2543ZM1.81853 10.7475C1.37557 11.5249 1.37752 12.4786 1.81966 13.2543L3.12283 12.5115C2.94218 12.1946 2.9421 11.8055 3.12179 11.4901L1.81853 10.7475ZM12 14.5C10.6192 14.5 9.49996 13.3807 9.49996 12H7.99996C7.99996 14.2091 9.79082 16 12 16V14.5ZM9.49996 12C9.49996 11.3094 9.77896 10.6855 10.2322 10.2322L9.17153 9.17157C8.4485 9.89461 7.99996 10.8956 7.99996 12H9.49996ZM13.7677 13.7678C13.3145 14.221 12.6905 14.5 12 14.5V16C13.1043 16 14.1054 15.5515 14.8284 14.8284L13.7677 13.7678Z"
                fill="currentColor" />
              </svg>
              <svg v-else-if="password?.length" xmlns="http://www.w3.org/2000/svg" key="hide-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" class="h-4">
                <path d="M2.47032 11.1187L1.81869 10.7474H1.81869L2.47032 11.1187ZM21.5298 11.1188L22.1814 10.7475V10.7475L21.5298 11.1188ZM2.47032 12.8811L1.81869 13.2524H1.81869L2.47032 12.8811ZM21.5298 12.8812L22.1814 13.2526V13.2526L21.5298 12.8812ZM3.12194 11.49C5.43733 7.42677 8.76885 5.49998 12 5.5C15.2312 5.50002 18.5627 7.42687 20.8781 11.4901L22.1814 10.7475C19.6579 6.31907 15.8791 4.00003 12 4C8.12093 3.99997 4.34216 6.31896 1.81869 10.7474L3.12194 11.49ZM1.81869 13.2524C4.34216 17.6809 8.12092 19.9999 12 19.9999C15.8791 20 19.6579 17.681 22.1814 13.2526L20.8781 12.5099C18.5627 16.5732 15.2312 18.5 12 18.4999C8.76886 18.4999 5.43733 16.5731 3.12194 12.5098L1.81869 13.2524ZM1.81869 10.7474C1.37619 11.5239 1.37619 12.4759 1.81869 13.2524L3.12194 12.5098C2.94177 12.1936 2.94177 11.8062 3.12194 11.49L1.81869 10.7474ZM20.8781 11.4901C21.0583 11.8063 21.0583 12.1937 20.8781 12.5099L22.1814 13.2526C22.6239 12.476 22.6239 11.524 22.1814 10.7475L20.8781 11.4901ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5V16C14.2092 16 16 14.2091 16 12H14.5ZM12 14.5C10.6193 14.5 9.50004 13.3807 9.50004 12H8.00004C8.00004 14.2091 9.7909 16 12 16V14.5ZM9.50004 12C9.50004 10.6193 10.6193 9.5 12 9.5V8C9.7909 8 8.00004 9.79086 8.00004 12H9.50004ZM12 9.5C13.3807 9.5 14.5 10.6193 14.5 12H16C16 9.79086 14.2092 8 12 8V9.5Z"
                fill="currentColor" />
              </svg>
            </transition>
          </button>
        </div>
        <transition name="error">
          <div v-if="passwordError" class="w-full flex items-end h-7">
            <BaseText type="body" size="sm" style="color: #DF1C41">
              Please enter a valid password
            </BaseText>
          </div>
        </transition>
        <!-- Sign In Button -->
        <button class="submit-button w-full mt-6 p-2 h-10 bg-white flex items-center justify-center transition duration-200"
        :class="loadingEmailLink ? 'cursor-default' : 'hover:bg-opacity-90'"
        type="submit" :disabled="loadingEmailLink" :loading="loadingEmailLink">
          <BaseLoadingSpinnerCircle v-if="loadingEmailLink" :duration="1" />
          <BaseText v-else type="heading" size="sm">
            Sign In
          </BaseText>
        </button>
      </form>

      <!-- Divider + Google Sign In (login state only) -->
      <template v-if="status === 'login'">
        <div class="w-full flex items-center gap-6 py-1 mt-3 xs:mt-6">
          <div class="flex-grow h-0 border-t border-neutral-alpha-50" />
          <BaseText type="body" size="sm" class="text-neutral-alpha-650">
            or
          </BaseText>
          <div class="flex-grow h-0 border-t border-neutral-alpha-50" />
        </div>
        <button class="google-btn w-full flex items-center justify-center gap-2.5 p-2 mt-4"
        @click="signInWithGoogle">
          <img src="../../assets/images/google-logo.png" class="w-5 h-5" style="opacity: 0.68">
          <BaseText type="heading" size="sm" class="text-white">
            Sign in with Google
          </BaseText>
        </button>
      </template>

      <!-- loading / awaiting_user / awaiting_initial_load / linking / redirecting -->
      <div v-else-if="['loading', 'awaiting_user', 'awaiting_initial_load', 'linking', 'redirecting'].includes(status)"
      class="w-full mt-12 flex flex-col items-center gap-4">
        <BaseLoadingSpinnerCircle :duration="1" />
        <BaseText v-if="status === 'linking'" type="body" size="sm" class="text-neutral-alpha-650">
          Connecting your account…
        </BaseText>
        <BaseText v-else-if="status === 'redirecting'" type="body" size="sm" class="text-neutral-alpha-650">
          Redirecting…
        </BaseText>
      </div>

      <!-- error -->
      <div v-else-if="status === 'error'" class="w-full mt-12 flex flex-col items-center gap-4">
        <InfoIcon style="color: #DF1C41" :width="28" :height="28" />
        <BaseText type="body" size="sm" class="text-neutral-alpha-650 text-center">{{ runtimeError }}</BaseText>
        <button class="submit-button w-full p-2 h-10 bg-white flex items-center justify-center transition duration-200 hover:bg-opacity-90" @click="retry">
          <BaseText type="heading" size="sm">Retry</BaseText>
        </button>
        <button class="outlined-button w-full p-2 h-10" @click="cancel">
          <BaseText type="heading" size="sm" class="text-white">Cancel</BaseText>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import firebase from '@/api/config/FirebaseConfig'
import InfoIcon from '@/components/globals/Icons/InfoSimpleIcon.vue'
import MCPLogoIcon from '@/components/globals/Icons/MCPLogoIcon.vue'
import { linkUser, getAuthorizeUrl } from '@/api/foreplayServer/McpOauthRequests'

const ALLOWED_REDIRECT_PROTOCOLS = ['https:']
const isAllowedRedirectUri = (uri) => {
  try {
    const u = new URL(uri)
    if (ALLOWED_REDIRECT_PROTOCOLS.includes(u.protocol)) return true
    if (u.protocol === 'http:' && (u.hostname === 'localhost' || u.hostname === '127.0.0.1')) return true
    // Custom URL schemes used by IDE-style MCP clients (e.g. cursor://, vscode://)
    if (u.protocol && u.protocol !== 'http:' && u.protocol !== 'https:' && u.protocol !== 'javascript:') return true
    return false
  } catch {
    return false
  }
}

const CLIENT_NAMES = {
  'claude-mcp': 'Claude',
  'cursor-mcp': 'Cursor'
}

const FEATURES = [
  { id: 'boards', title: 'Boards', description: "Organize and access the ad collections you've saved." },
  { id: 'spyder', title: 'Spyder', description: 'Track competitor brands and see ads they\'re running.' },
  { id: 'discovery', title: 'Discovery', description: 'Search across millions of ads from the Foreplay library.' },
  { id: 'ads', title: 'Ads', description: 'Read details, transcripts, and metadata for ads in your library.' },
  { id: 'brands', title: 'Brands', description: 'Look up brand profiles and their ad activity.' }
]

// public.api error bodies carry the cause in error.details; data.message is our proxy's own shape.
const errorMessage = (e) => e?.response?.data?.error?.details || e?.response?.data?.message || e?.message

const titleCase = (str) => str.replace(/[-_]/g, ' ').replace(/\b\w/g, c => c.toUpperCase())

export default {
  name: 'McpOauthAuthorizeView',
  components: {
    InfoIcon,
    MCPLogoIcon
  },
  data () {
    return {
      status: 'loading',
      unsubAuth: null,
      oauthParams: {
        response_type: '',
        client_id: '',
        redirect_uri: '',
        state: '',
        scope: '',
        code_challenge: '',
        code_challenge_method: '',
        resource: ''
      },
      paramError: null,
      runtimeError: null,
      retryStatus: null,
      email: '',
      password: '',
      loadingEmailLink: false,
      emailError: false,
      passwordError: false,
      showPassword: false,
      emailInputFocused: false,
      passwordInputFocused: false
    }
  },
  computed: {
    ...mapGetters('AuthModule', ['getUser', 'getTeam', 'getHasApiAccess', 'getInitialLoad']),
    features () {
      return FEATURES
    },
    userEmail () {
      return this.getUser?.email || firebase.auth().currentUser?.email
    },
    friendlyClientName () {
      const id = this.oauthParams.client_id
      return CLIENT_NAMES[id] || titleCase(id || 'this app')
    },
    workspaceLabel () {
      return this.getTeam?.name || `${this.userEmail || 'Personal'} workspace`
    },
    blockReason () {
      if (!this.getHasApiAccess) return 'no_api_subscription'
      return null
    },
    canApprove () {
      return this.blockReason === null
    },
    blockHeading () {
      if (this.blockReason === 'no_api_subscription') {
        return 'No workspace is currently ready for MCP OAuth access. Review the details below.'
      }
      return ''
    },
    blockBadge () {
      if (this.blockReason === 'no_api_subscription') return 'Upgrade required'
      return ''
    },
    blockDetail () {
      if (this.blockReason === 'no_api_subscription') {
        return `${this.workspaceLabel} needs an active Foreplay API subscription before it can be connected through MCP OAuth.`
      }
      return ''
    },
    consentTheme () {
      const isBlocked = this.blockReason === 'no_api_subscription'
      if (isBlocked) {
        return {
          accentColor: '#FFF6E0',
          accentColorAlpha76: 'rgba(255,246,224,0.76)',
          cardGradient: 'linear-gradient(0deg, rgba(255,190,76,0) 0%, rgba(255,190,76,0.08) 100%), linear-gradient(90deg, rgba(255,190,76,0.12) 0%, rgba(255,190,76,0.12) 100%)',
          outerTitle: 'Foreplay Account Connection',
          outerBody: 'No Foreplay team/workspace is currently ready for MCP OAuth access. Review the details below.',
          innerBody: 'This team needs an active Foreplay API key before it can be connected through MCP OAuth.',
          actionLabel: 'Activate API',
          actionHref: '/api-overview'
        }
      }
      return {
        accentColor: '#EFFEFA',
        accentColorAlpha76: 'rgba(239,254,250,0.76)',
        cardGradient: 'linear-gradient(0deg, rgba(64,196,170,0) 0%, rgba(64,196,170,0.08) 100%), linear-gradient(90deg, rgba(64,196,170,0.12) 0%, rgba(64,196,170,0.12) 100%)',
        outerTitle: 'Foreplay Account Connected',
        outerBody: 'You are connecting a Foreplay team for MCP via OAuth access. Review the details below.',
        innerBody: 'This team has an active Foreplay API Key. If you have any usage issues you can increase your API plan size.',
        actionLabel: 'API Details',
        actionHref: '/api-overview'
      }
    }
  },
  watch: {
    getUser (newVal) {
      // Firebase auth signed in → Vuex user populated by main.js.
      // Don't advance until getInitialLoad is true (subscription/team settled).
      if (newVal?.user_id && this.status === 'awaiting_user' && this.getInitialLoad) {
        this.status = 'linking'
        this.linkAndContinue()
      } else if (newVal?.user_id && this.status === 'awaiting_user') {
        this.status = 'awaiting_initial_load'
      }
    },
    getInitialLoad (loaded) {
      // External subscription / team data has finished loading. Safe to evaluate gate.
      if (loaded && this.status === 'awaiting_initial_load') {
        this.status = 'linking'
        this.linkAndContinue()
      }
    }
  },
  created () {
    this.oauthParams.response_type = this.$route.query.response_type || ''
    this.oauthParams.client_id = this.$route.query.client_id || ''
    this.oauthParams.redirect_uri = this.$route.query.redirect_uri || ''
    this.oauthParams.state = this.$route.query.state || ''
    this.oauthParams.scope = this.$route.query.scope || ''
    this.oauthParams.code_challenge = this.$route.query.code_challenge || ''
    this.oauthParams.code_challenge_method = this.$route.query.code_challenge_method || ''
    this.oauthParams.resource = this.$route.query.resource || ''

    if (!this.oauthParams.redirect_uri || !this.oauthParams.client_id) {
      this.status = 'invalid_params'
      this.paramError = 'Missing required OAuth parameters.'
      return
    }
    if (!isAllowedRedirectUri(this.oauthParams.redirect_uri)) {
      this.status = 'invalid_params'
      this.paramError = 'Invalid redirect URI.'
      return
    }

    // Wait for Firebase to restore auth state (async on page load).
    this.unsubAuth = firebase.auth().onAuthStateChanged((user) => {
      // Only advance from a pre-auth state — ignore re-fires (token refresh, etc.).
      if (!['loading', 'login', 'awaiting_user', 'awaiting_initial_load'].includes(this.status)) return
      if (user) {
        if (!this.getUser?.user_id) {
          // Vuex user not yet populated (main.js fetches it).
          this.status = 'awaiting_user'
        } else if (!this.getInitialLoad) {
          // User hydrated but subscription/team data not yet settled.
          this.status = 'awaiting_initial_load'
        } else {
          this.status = 'linking'
          this.linkAndContinue()
        }
      } else if (this.status === 'loading') {
        this.status = 'login'
      }
    })
  },
  beforeDestroy () {
    if (this.unsubAuth) this.unsubAuth()
  },
  mounted () {
    if (window.analytics) {
      window.analytics.page('MCP OAuth Authorize Viewed', {
        client_id: this.oauthParams.client_id,
        scope: this.oauthParams.scope
      })
    }
  },
  methods: {
    async sendEmailLink () {
      if (!this.email?.length) this.emailError = true
      if (!this.password?.length) this.passwordError = true
      if (this.emailError || this.passwordError) return

      this.loadingEmailLink = true

      try {
        // Bypass AuthModule.loginUserWithEmailAndPassword — it hard-redirects
        // to /discovery, which would break this OAuth consent flow.
        // main.js's onAuthStateChanged will populate Vuex user from the backend.
        await firebase.auth().signInWithEmailAndPassword(this.email, this.password)
      } catch (e) {
        this.$showAlert({
          message: e.message,
          type: 'error'
        })
      } finally {
        this.loadingEmailLink = false
      }
    },
    async signInWithGoogle () {
      try {
        const provider = new firebase.auth.GoogleAuthProvider()
        await firebase.auth().signInWithPopup(provider)
      } catch (e) {
        this.$showAlert({
          message: e.message,
          type: 'error'
        })
      }
    },
    async linkAndContinue () {
      // No-op if the gate would block — we won't create Keycloak users for non-admins
      // or unsubscribed accounts. Just show the consent screen with the blocked state.
      if (!this.canApprove) {
        this.status = 'consent'
        return
      }
      try {
        const foreplayUserId = this.getUser?.user_id || this.getUser?.id
        if (!foreplayUserId) throw new Error('Could not determine your Foreplay user ID.')
        await linkUser({
          foreplayUserId,
          email: this.userEmail,
          username: this.userEmail
        })
        this.status = 'consent'
      } catch (e) {
        this.runtimeError = errorMessage(e) || 'Failed to link your account.'
        this.retryStatus = 'linking'
        this.status = 'error'
        this.$showAlert({ type: 'error', message: this.runtimeError })
      }
    },
    async approve () {
      if (!this.canApprove) return
      this.status = 'redirecting'
      try {
        const data = await getAuthorizeUrl(this.oauthParams)
        const url = data?.data?.authorization_url || data?.authorization_url || data?.data?.authorize_url || data?.authorize_url || data?.data?.url || data?.url
        if (!url) throw new Error('Authorization URL not returned.')
        if (window.analytics) {
          window.analytics.track('MCP OAuth Approved', { client_id: this.oauthParams.client_id })
        }
        window.location.href = url
      } catch (e) {
        this.runtimeError = errorMessage(e)
        this.retryStatus = 'consent'
        this.status = 'error'
        this.$showAlert({ type: 'error', message: this.runtimeError })
      }
    },
    cancel () {
      if (window.analytics) {
        window.analytics.track('MCP OAuth Cancelled', { client_id: this.oauthParams.client_id })
      }
      if (!isAllowedRedirectUri(this.oauthParams.redirect_uri)) {
        this.$showAlert({ type: 'error', message: 'Invalid redirect URI.' })
        return
      }
      try {
        const url = new URL(this.oauthParams.redirect_uri)
        url.searchParams.set('error', 'access_denied')
        if (this.oauthParams.state) url.searchParams.set('state', this.oauthParams.state)
        window.location.href = url.toString()
      } catch (e) {
        this.$showAlert({ type: 'error', message: 'Invalid redirect URI.' })
      }
    },
    retry () {
      this.runtimeError = null
      if (this.retryStatus === 'linking') {
        this.status = 'linking'
        this.linkAndContinue()
      } else if (this.retryStatus === 'consent') {
        this.status = 'consent'
      }
    }
  },
  metaInfo: {
    title: 'Authorize MCP App | Foreplay.co'
  }
}
</script>

<style scoped>
.submit-button {
  color: #13151A;
  border-radius: 10px;
}

.outlined-button {
  border: 1px solid;
  border-color: rgba(255, 255, 255, 0.16);
  background-color: transparent;
  border-radius: 10px;
  transition: border-color 150ms ease-in-out, background-color 150ms ease-in-out;
}
.outlined-button:hover {
  border-color: transparent;
  background-color: rgba(255, 255, 255, 0.08);
}

.approve-button {
  background-color: #44C56B;
  color: #FFFFFF;
  border-radius: 10px;
}
.approve-button:disabled {
  pointer-events: none;
}

.google-btn {
  border: 1px solid;
  border-color: rgba(255, 255, 255, 0.16);
  background-color: transparent;
  border-radius: 10px;
  transition: border-color 150ms ease-in-out, background-color 150ms ease-in-out;
}
.google-btn:hover {
  border-color: transparent;
  background-color: rgba(255, 255, 255, 0.08);
}

.input-container {
  background-color: rgba(255, 255, 255, 0.10);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.10);
  border-radius: 10px;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  transition: background-color 150ms ease-in-out, box-shadow 150ms ease-in-out;
}
.input-container:hover {
  background-color: rgba(255, 255, 255, 0.16);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.16);
}
.input-container.active, .input-container.active:hover {
  background-color: transparent;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.10);
}
.input-container.errored, .input-container.active.errored, .input-container.active.errored:hover {
  background-color: transparent;
  box-shadow: 0 0 0 1px #F4003A;
}

.form-input {
  background-color: transparent;
  color: white;
  caret-color: white;
  max-width: none;
  font-weight: 300;
  font-size: 16px;
  line-height: 24px;

  /* Reset default styles */
  -webkit-appearance: none;  /* Remove default styling in WebKit browsers */
  -moz-appearance: none;     /* Remove default styling in Firefox */
  appearance: none;          /* Remove default styling in modern browsers */
  padding: 0;
  margin: 0;
  border: none;
  font-size: inherit;
  outline: none;

  /* This is because browsers want to force their ugly styling on you when autofill is triggered. */
  /* This is the only way to prevent that, since they use !important in their overrides. */
  transition:
    color 99999999s step-end,
    background-color 99999999s step-end;
}
.form-input:focus {
  outline: none;
  border: none;
  box-shadow: none;
}
.form-input::placeholder {
  transition: color 200ms ease-in-out;
  color: rgba(255, 255, 255, 0.44);
}
.form-input:focus::placeholder {
  color: rgba(255, 255, 255, 0.2);
}

/* Override browser autofill styles */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: white !important;
}

/* Firefox autocomplete */
.form-input:-moz-autofill {
  color: white !important;
}

/* General autocomplete prevention */
.form-input:autofill {
  color: white !important;
}

.visibility-enter-active, .visibility-leave-active {
  transition: opacity 75ms ease-in-out;
  position: absolute;
  right: 0px;
  top: 4px;
}
.visibility-enter-from, .visiblity-enter, .visibility-leave-to {
  opacity: 0;
}
.visibility-enter-to, .visibility-leave-from {
  opacity: 1;
}
.v-enter-active, .v-leave-active {
  transition: opacity 75ms ease-in-out;
}
.v-enter-from, .v-enter, .v-leave-to {
  opacity: 0;
}
.v-enter-to, .v-leave-from {
  opacity: 1;
}
.error-enter-active {
  animation: errorEnter 75ms ease-in-out forwards;
}
.error-leave-active {
  animation: errorLeave 75ms ease-in-out forwards;
}
@keyframes errorEnter {
  0% { height: 0px; opacity: 0; }
  50% { opacity: 0; }
  100% { height: 28px; opacity: 1; }
}
@keyframes errorLeave {
  0% { height: 28px; opacity: 1; }
  50% { opacity: 0; }
  100% { height: 0px; opacity: 0; }
}

.mcp-deny-btn {
  height: 32px;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid rgba(255,255,255,0.12);
  background-color: transparent;
  color: rgba(255,255,255,0.76);
  font-family: Inter, system-ui, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  transition: background-color 150ms ease-in-out, border-color 150ms ease-in-out, color 150ms ease-in-out;
  cursor: pointer;
}
.mcp-deny-btn:hover {
  background-color: rgba(255,255,255,0.06);
  border-color: rgba(255,255,255,0.24);
  color: #FFFFFF;
}

.mcp-allow-btn {
  height: 32px;
  padding: 6px 10px;
  border-radius: 8px;
  border: none;
  color: #EFFEFA;
  font-family: Inter, system-ui, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  background-image:
    linear-gradient(180deg, rgba(64,196,170,0) 0%, rgba(64,196,170,0.12) 100%),
    linear-gradient(90deg, rgba(64,196,170,0.24) 0%, rgba(64,196,170,0.24) 100%);
  transition: background-image 150ms ease-in-out, opacity 150ms ease-in-out;
  cursor: pointer;
}
.mcp-allow-btn:hover:not(:disabled) {
  background-image:
    linear-gradient(180deg, rgba(64,196,170,0) 0%, rgba(64,196,170,0.16) 100%),
    linear-gradient(90deg, rgba(64,196,170,0.32) 0%, rgba(64,196,170,0.32) 100%);
}
.mcp-allow-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
</style>
